__webpack_require__.p = "/witryna/_next/";